import { render, staticRenderFns } from "./CardResultRecipe.vue?vue&type=template&id=393197e5&scoped=true"
import script from "./CardResultRecipe.vue?vue&type=script&lang=js"
export * from "./CardResultRecipe.vue?vue&type=script&lang=js"
import style0 from "./CardResultRecipe.vue?vue&type=style&index=0&id=393197e5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "393197e5",
  null
  
)

export default component.exports